import type { LocationLocale } from './generate-localized-location-url';

/** Single-segment region slugs that must not get a city-style country suffix. */
const REGION_ONLY_SLUGS = new Set([
  'Finland',
  'Suomi',
  'Europe',
  'Eurooppa',
  'Europa',
  'Remote',
  'Global',
  'MENA',
  'Distans',
  'Etätyö',
  'Etatyo',
]);

/**
 * Appends `_Finland` / `_Suomi` to town-only location slugs so SSR hrefs match
 * server redirect rules (see url-rewrite-config city-only segment rules).
 */
export function ensureTownOnlyLocationSlugHasCountrySuffix(
  slug: string,
  locale: LocationLocale,
): string {
  if (!slug || slug.includes('_')) return slug;
  if (REGION_ONLY_SLUGS.has(slug)) return slug;

  return locale === 'fi' ? `${slug}_Suomi` : `${slug}_Finland`;
}
